import React from "react";
import styles from "../../components/call/teamCallHold/TeamCallHoldDetail.module.scss";
import { Modal } from "antd";
import { URButton } from "../../shared/widgets/button";
import { useHistory } from "react-router-dom";
import { Cookie } from "../../base/utils";
import myacntImg from "../../styles/images/myaccount.svg";

type TourModalProps = { managekeys: Function, tourKey: number };

const TourModal = ({ managekeys, tourKey }: TourModalProps) => {
    const history = useHistory();

    const changeKeys = (keys: number) => {
        managekeys(keys);
        switch (keys) {
            case 1:
                if (window.location.pathname !== '/chats') {
                    history && history.push('/chats');

                }
                break;
            case 2:
                if (window.location.pathname !== '/calls') {

                    history && history.push('/calls');
                }
                break;
            case 3:
                if (window.location.pathname !== '/contacts') {
                    history && history.push('/contacts');
                }
                break;
            case 4:
                if (window.location.pathname !== '/meeting') {
                    history && history.push('/meeting');
                }
                break;

        }
        if (keys === -1) {
            Cookie.set('startTour', '1',365);     
        }

    }


    return (
        <>

                <Modal visible={tourKey === 1} className={`tourmodalone ${styles.tourmodal} ${"modaloverwritetour"}`}>
                    <h1 className="modalicon chatimgbefore">
                        {/* <ul>
                            <li className="active">
                            <span className="icon__MessageGrey active"></span>rt
                            </li>
                        </ul> */}

                      {/* <span className="icon__MessageGrey active"></span> */}
                    </h1>
                    <span className={`icon_close ${styles.cursorTop}`} onClick={(e: any) => changeKeys(-1)} />
                    <h2>Chat <span>1 of 7</span></h2>
                    <p>
                        Collaborate seamlessly and securely with your team using advanced chat features!
                    </p>
                    <div className="footersection">

                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(2)} name="Next"></URButton>
                    </div>
                </Modal>


                <Modal visible={tourKey === 2} className={`tourmodalone tourmodaltwo ${styles.tourmodal} ${"modaloverwritetour"}`}>
                    <h1 className="modalicon callimgbefore">
                        {/* <ul>
                            <li className="active"></li>
                            <span className="icon__CallGrey active"></span>                        

                        </ul> */}
                    </h1>
                    <span className={`icon_close ${styles.cursorTop}`} onClick={(e: any) => changeKeys(-1)} />
                    <h2>Call <span>2 of 7</span></h2>
                    <p>
                        Say goodbye to call quality frustrations and hello to uninterrupted communication! With advanced call control features and HD quality.
                    </p>
                    <div className="footersection">
                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(1)} name="Back"></URButton>

                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(3)} name="Next"></URButton>
                    </div>
                </Modal>


                <Modal visible={tourKey === 3} className={`tourmodalone tourmodalthree ${styles.tourmodal} ${"modaloverwritetour"}`}>
                 <h1 className="modalicon contactimgbefore ">
                     {/* <ul>
                        <li className="active">
                        <span className="icon__ContactGrey active"></span>                        

                        </li>
                        </ul> */}
                        </h1>
                    <span className={`icon_close ${styles.cursorTop}`} onClick={(e: any) => changeKeys(-1)} />
                    <h2>Contacts<span> 3 of 7</span></h2>
                    <p> Stay organized and connected with Worktual&apos;s all-in-one contact management app!</p>
                    <div className="footersection">
                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(2)} name="Back"></URButton>

                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(4)} name="Next"></URButton>
                    </div>
                </Modal>



                <Modal visible={tourKey === 4} className={`tourmodalone tourmodalfour ${styles.tourmodal} ${"modaloverwritetour"}`}>
                <h1 className="modalicon meetimgbefore">
                    {/* <ul>
                        <li className="active">
                        <span className="icon__MeetGrey active"></span>                        

                        </li>
                        </ul> */}
                        </h1>
                    <span className={`icon_close ${styles.cursorTop}`} onClick={(e: any) => changeKeys(-1)} />
                    <h2>Meet<span> 4 of 7</span></h2>
                    <p>Unleash your team&apos;s full potential with Worktual&apos;s Meet! That will have your team collaborating like rockstars, without breaking a sweat.</p>
                    <div className="footersection">
                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(3)} name="Back"></URButton>

                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(5)} name="Next"></URButton>
                    </div>
                </Modal>

                <Modal visible={tourKey === 5} className={`tourmodalone tourmodalfive ${styles.tourmodal} ${"modaloverwritetour"}`}>
                <h1 className="modalicon settingimgbefore">
                    {/* <ul>
                        <li className="active"></li>
                        <img src={myacntImg} alt=""/>

                        </ul> */}
                        </h1>
                    <span className={`icon_close ${styles.cursorTop}`} onClick={(e: any) => changeKeys(-1)} />
                    <h2>Go to My Application<span> 5 of 7</span></h2>
                    <p>Customise your Worktual account settings to suit your communication and collaboration needs, without sacrificing security and integrity! Get ready to work your way, on your terms.</p>
                    <div className="footersection">
                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(4)} name="Back"></URButton>

                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(6)} name="Next"></URButton>
                    </div>
                </Modal>



                <Modal visible={tourKey === 6} className={`tourmodalone tourmodalsix ${styles.tourmodal} ${"modaloverwritetour"}`}>
                <h1 className="modalicon alterPlace4"><ul>
                        <li className="active"></li>
                        </ul></h1>
                    <span className={`icon_close ${styles.cursorTop}`} onClick={(e: any) => changeKeys(-1)} />
                    <h2>Primary Option “New”<span> 6 of 7</span></h2>
                    <p>This primary button helps you to have a quick access across menus to send messages, make calls, create meetings and assign tasks.</p>
                    <div className="footersection">
                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(5)} name="Back"></URButton>

                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(7)} name="Next"></URButton>
                    </div>
                </Modal>

                <Modal visible={tourKey === 7} className={`tourmodalone tourmodalseven ${styles.tourmodal} ${"modaloverwritetour"}`}>
                <h1 className="modalicon alterPlace5"><ul>
                        <li className="active"></li>
                        </ul></h1>
                    <span className={`icon_close ${styles.cursorTop}`} onClick={(e: any) => changeKeys(-1)} />
                    <h2>User Profile<span> 7 of 7</span></h2>
                    <p>
                        Take control of your personal information and settings with Worktual! Keep things up-to-date and under control with just a few clicks, so you can focus on what really matters - getting stuff done!   </p>
                    <div className="footersection">
                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(6)} name="Back"></URButton>

                        <URButton className="nextbtn" onClick={(e: any) => changeKeys(-1)} name="Done"></URButton>
                    </div>
                </Modal>


        </>
    );
};

export default TourModal;